import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38b97354"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["aria-expanded", "data-accordion-target", "aria-controls"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "data-accordion-icon": "",
  class: "w-6 h-6 rotate-180 shrink-0",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_5 = ["id", "aria-labelledby"]

import { onMounted, onUpdated, ref } from "vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import CollapsibleContainer from "@/layout/collapsible/CollapsibleContainer.vue";
import { initAccordions } from "flowbite";
import { storeToRefs } from "pinia";
import { patientStore } from "@/store/patient";


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleItem',
  props: {
  data: Object,

},
  emits: ["rowActions", "create-form", "search"],
  setup(__props, { emit }) {

const props = __props;

const btnCollapsable = ref<InstanceType<typeof HTMLButtonElement> | null>(null);

const store = patientStore();
const { patient } = storeToRefs(store);





const isOpen = ref(false);


// initialize components based on data attribute selectors
onMounted(() => {
 

  if (store.collapsableStatus[props.data?.data + props.data?.filterValue] == null) {
    store.collapsableStatus[props.data?.data + props.data?.filterValue] = false
  }
  isOpen.value = store.collapsableStatus[props.data?.data + props.data?.filterValue]
  initAccordions();

});

function updateStatus() {
  isOpen.value = !isOpen.value

  store.collapsableStatus[props.data?.data + props.data?.filterValue] = isOpen.value
  
}

function search(word: string, check: boolean) {
  emit('search', word, check);
}

function createForm() {
  emit("create-form");
}
function action(type: string, row: any, index: number) {
  emit("rowActions", type, row, index);
}



onUpdated(() => {

  initAccordions();

});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: 'accordion-collapse-' + __props.data?.data + __props.data?.filterValue,
    "data-accordion": "open",
    class: "colcontainer"
  }, [
    _createElementVNode("h2", {
      id: 'accordion-collapse-heading-' + __props.data?.data + __props.data?.filterValue
    }, [
      _createElementVNode("button", {
        ref_key: "btnCollapsable",
        ref: btnCollapsable,
        onClick: updateStatus,
        type: "button",
        "aria-expanded": isOpen.value,
        class: "collapsible flex items-center justify-between w-full p-5 font-medium text-right text-gray-500 rounded-t-xl dark:text-gray-400",
        "data-accordion-target": '#accordion-collapse-body-' + __props.data?.data + __props.data?.filterValue,
        "aria-controls": 'accordion-collapse-body-' + __props.data?.data + __props.data?.filterValue
      }, [
        _createElementVNode("span", null, [
          _createElementVNode("div", {
            class: _normalizeClass(__props.data?.dotColor)
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(__props.data?.title), 1)
        ]),
        _renderSlot(_ctx.$slots, "additional_button"),
        _hoisted_4
      ], 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      id: 'accordion-collapse-body-' + __props.data?.data + __props.data?.filterValue,
      class: "hidden",
      "aria-labelledby": 'accordion-collapse-heading-' + __props.data?.data + __props.data?.filterValue
    }, [
      _createVNode(CollapsibleContainer, {
        onRowActions: action,
        onCreateForm: _cache[0] || (_cache[0] = ($event: any) => (createForm())),
        data: __props.data,
        class: "containerItem",
        onSearch: _cache[1] || (_cache[1] = (w,c)=>search(w,c))
      }, null, 8, ["data"]),
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_5)
  ], 8, _hoisted_1))
}
}

})